import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const HorasFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='HORAS' htmlFor='number-horas' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='horas'>
          {({ field }) => <Form.InputNumber {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='number-horas' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(HorasFormGroup)
